import { Dispatch } from "react"

export default function Tabs({ tabs, value, setValue, theme = 'primary', customClass = '' }: { tabs: { title: string | JSX.Element, value: string }[], value: string, setValue: Dispatch<React.SetStateAction<string>>|((value: string)=>void), theme?: 'primary' | 'secondary', customClass?: string }) {
  return (
    <div className={`tabs ${theme}-theme ${customClass}`}>
      {tabs.map(tab => {
        return (
          <div
            className={`tab ${value === tab.value ? 'active' : ''}`}
            onClick={() => {
              setValue(tab.value)
            }}
          >
            {tab.title}
          </div>
        )
      })}
    </div>
  )
}